import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { AdjustmentRuleAction } from '@cbridge-packages/adjustment-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidateAdjustmentRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    AdjustmentRuleAction.validate.done,
  ),
  mergeMap((payload) => {
    return [RulesManagementAction.applyValidation(payload.result)];
  }),
);
